/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name inputdatetime
 * @description Combonation date and time picker.
 * @attr {String} next-element Selector used to the next element to focus if tab is pressed
 * @attr {Boolean} remove-time-picker flag to remove the time picker
 */
angular.module('mercury.directives.inputdatetime', [])
.directive('inputdatetime', ["$compile", "$document", "$parse", "$timeout", function($compile, $document, $parse, $timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: true,
    link: function(scope, element, attrs, modelCtrl) {
      //Format the model displayed on the input box.
      modelCtrl.$formatters.push(function(value) {
        if (value) {
          return moment(value).format('DD MMM YYYY, h:mma');
        } else {
          return '';
        }
      });

      //The input should be read only
      element.attr('readonly', 'readonly');

      var popupEl = null;

      scope.$watch(attrs.ngModel, function(value) {
        if (value) {
          scope.time = angular.copy(value);
          scope.date = angular.copy(value);
        }
      });

      /**
      * ngChange callback for setting the time or date
      */
      scope.updateDateTime = function() {
        //If the user is entering hours or minutes in the inputs of the timepicker, the time can be null
        //If this is the case, don't continue until the time is valid again.
        if (!scope.time) {
          return;
        }

        var dateComponent = moment(scope.date);
        var timeComponent = moment(scope.time);

        var newDate = moment([
          dateComponent.year(),
          dateComponent.month(),
          dateComponent.date(),
          timeComponent.hour(),
          timeComponent.minute()
        ]);

        //Update the model and the displayed labal
        $timeout(function() {
          $parse(attrs.ngModel).assign(scope, newDate.format());
          scope.$eval(attrs.ngChange);
        }, 50);
      };

      /**
      * Close function.
      */
      scope.close = function() {
        if (popupEl !== null) {
          //Remove the document events added for this popup.
          $document.off('mousedown.loadedDateTime');
          $document.off('keydown.loadedDateTime');

          scope.updateDateTime();

          popupEl.remove();
          popupEl = null;

          var currentVal = $parse(attrs.ngModel)(scope);

          if (currentVal !== initialValue && attrs.ngChange) {
            $timeout(function() {
              scope.$eval(attrs.ngChange);
            }, 5);
          }
        }
      };

      /**
      * Focus event for the trigger input.
      */
      element.on('focus', function() {

        //We need to check if the popover is being open in a modal window.
        //Then check what size screen is being used...
        var isInModal = ($(element).closest('.modal-dialog').length > 0) ? true : false;
        var popWidth = (isInModal) ? (($(window).width() > 768) ? '480px' : '100%') : (($(window).width() > 768) ? '480px' : '250px');

        if (popupEl === null) {
          var template = '';

          // if we do not want to display the time picker then remove it from the template
          if (angular.isDefined(attrs.removeTimePicker)) {
            popWidth = (isInModal) ? (($(window).width() > 768) ? '240px' : '100%') : (($(window).width() > 768) ? '240px' : '250px');
            template = '<div style="position: relative;" class="table-condensed">' +
              // '<div class="popover" style="width: ' + popWidth + '; max-width: ' + popWidth + '; padding: 5px;">' +
              '<div class="popover">' +
              '   <div inputdate ng-model="date"></div>' +
              '</div>';
          } else {
            template = '<div style="position: relative;" class="table-condensed">' +
              '<div class="popover" style="width: ' + popWidth + '; max-width: ' + popWidth + '; padding: 5px;">' +
              '    <div class="row">' +
              '        <div class="col-sm-6">' +
              '            <div inputdate ng-model="date"></div>' +
              '        </div>' +
              '        <div class="col-sm-6">' +
              '            <div uib-timepicker ng-model="time" class="timepicker" style="margin-top: 50px;"></div>' +
              '            <div class="text-right">' +
              '                <button class="btn" ng-click="close()">Ok</button>' +
              '            </div>' +
              '        </div>' +
              '    </div>' +
              '</div>' +
              '</div>';
          }

          //Pull the datetime template and compile it
          popupEl = $compile(template)(scope);

          //Add the compiled element just after the input in the DOM
          element.after(popupEl);

          //If this element is contained in a modal, we need to use a fixed position instead of the default absolute one.
          if ($(element).closest('.modal').length) {
            angular.element(popupEl).find('#timepopup').css('position', 'fixed');
            var containerPosition = element.offset();
            containerPosition.top += element.outerHeight();
            angular.element(popupEl).find('#timepopup').offset(containerPosition);
          }

          //Give the date and time pickers to initialize then show the popover.
          $timeout(function() {
            popupEl.find('.popover').show();
          }, 1);

          //Store the initial value for use onClose
          initialValue = $parse(attrs.ngModel)(scope);

          /**
          * If there is a click anywhere outside of this directive, close the popup
          */
          $document.on('mousedown.loadedDateTime', function(e) {
            var targetNotInput = angular.element(e.target).get(0) != element.get(0);
            var targetNotPopup = popupEl.has(e.target).length === 0;

            if (targetNotInput && targetNotPopup) {
              scope.close();
            }
          });

          /**
          * The user presses tab while this popup is open, focus the next input
          */
          $document.on('keydown.loadedDateTime', function(e) {
            if (e.keyCode == 9) {//Tab
              $timeout(function() {
                //This parents next sibling that matches the next-element selector, focus it's first input or button.
                $(element).parent().siblings(attrs.nextElement).first().find('input,button').first().focus();
              }, 1);

              //Also close the current selector
              scope.close();
            }
          });

          /**
          * Highlight the hours & minutes when click
          */
          $document.on('click.loadedDateTime', function(e) {
            var targetNotInput = angular.element(e.target).get(0);
            if (targetNotInput.tagName == 'INPUT' &&
            (targetNotInput.parentElement.className.includes('hours') || targetNotInput.parentElement.className.includes('minutes'))) {
              targetNotInput.select();
            }
          });

        }
      });
    }
  };
}]);
